module.exports = __webpack_public_path__ + "img/turbozaem.d192cf9b.svg";